var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPhase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "#D0D3DA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9108C1.82241 16.5905 2.93289 16.5842 5.05747 15.9108L7.58621 8.32463L5.05747 0.738428C3.03976 0.264086 1.93137 0.253845 0 0.738428L2.52874 8.32463L0 15.9108Z",
    fill: "inherit"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPhase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phase.dbbd838115ae3e98f23574404eea5eac.svg";